(() => {
  const returnUrlStorageKey = 'legal-document-return-url';
  const policyPaths = ['/policies/privacy-policy', '/policies/terms-of-service'];

  const isPolicyUrl = (url) => policyPaths.some((path) => url.pathname.endsWith(path));

  const saveReturnUrl = (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const destinationUrl = new URL(link.href, window.location.href);
    if (destinationUrl.origin !== window.location.origin || !isPolicyUrl(destinationUrl)) return;
    if (isPolicyUrl(new URL(window.location.href))) return;

    try {
      window.sessionStorage.setItem(returnUrlStorageKey, window.location.href);
    } catch (_error) {
      // Browser history remains available when session storage is disabled.
    }
  };

  const getReturnUrl = () => {
    try {
      const storedUrl = window.sessionStorage.getItem(returnUrlStorageKey);
      if (!storedUrl) return null;

      const returnUrl = new URL(storedUrl);
      if (returnUrl.origin !== window.location.origin || isPolicyUrl(returnUrl)) return null;

      return returnUrl.href;
    } catch (_error) {
      return null;
    }
  };

  const clearReturnUrl = () => {
    try {
      window.sessionStorage.removeItem(returnUrlStorageKey);
    } catch (_error) {
      // Nothing to clear when session storage is disabled.
    }
  };

  const initializeLegalDocumentBackButtons = () => {
    document.querySelectorAll('[data-legal-document-back]').forEach((link) => {
      if (link.dataset.initialized === 'true') return;

      link.dataset.initialized = 'true';
      link.addEventListener('click', (event) => {
        if (
          event.defaultPrevented
          || event.button !== 0
          || event.metaKey
          || event.ctrlKey
          || event.shiftKey
          || event.altKey
        ) {
          return;
        }

        event.preventDefault();

        const returnUrl = getReturnUrl();
        if (returnUrl) {
          clearReturnUrl();
          window.location.assign(returnUrl);
          return;
        }

        const fallbackUrl = link.href;
        const currentUrl = window.location.href;

        if (window.history.length <= 1) {
          window.location.assign(fallbackUrl);
          return;
        }

        window.history.back();

        window.setTimeout(() => {
          if (window.location.href === currentUrl && document.visibilityState === 'visible') {
            window.location.assign(fallbackUrl);
          }
        }, 500);
      });
    });
  };

  document.addEventListener('click', saveReturnUrl, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeLegalDocumentBackButtons, { once: true });
  } else {
    initializeLegalDocumentBackButtons();
  }

  document.addEventListener('shopify:section:load', initializeLegalDocumentBackButtons);
})();
